import { inject } from '@angular/core';
import { type CanMatchFn } from '@angular/router';

import { AuthFacade, TokenStorage } from '@core/auth';

export const guestGuard: CanMatchFn = () => {
  if (inject(TokenStorage).hasValidSession()) {
    return inject(AuthFacade).redirectForAuthed();
  }

  return true;
};
